import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { toList } from '../../../utils/listUtils'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { PaymentOrder } from '../state/types'

export const usePaymentOrderLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadAllPaymentOrders = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.PAYMENT_ORDERS, options)
            return response.dataTypes as PaymentOrder[]
        }

        const loadPaymentOrder = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.PAYMENT_ORDERS, id, dbRequest) as Promise<O<PaymentOrder>>
        }

        const loadPaymentOrders = (ids: string[]) => {
            const { loadByIds } = loaders(companyId)
            return loadByIds(TableName.PAYMENT_ORDERS, ids) as Promise<PaymentOrder[]>
        }

        const loadPaymentOrdersWithProp = async (
            propName: string,
            dbRequest = false
        ) => {
            const { loadFiltered } = loaders(companyId)
            return loadFiltered(TableName.PAYMENT_ORDERS, dbRequest, undefined, undefined, toList(propName)) as Promise<PaymentOrder[]>
        }
        
        return {
            loadAllPaymentOrders,
            loadPaymentOrder,
            loadPaymentOrders,
            loadPaymentOrdersWithProp
        }
    }
}
